/**招标新增页面路径 */
export const TENDER_AUCTION_CREATE_PAGE_PATH = '/auction/tender/create'
